'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import Small from 'UIComponents/elements/Small';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import UISection from 'UIComponents/section/UISection';

const TimeZoneMessage = () => /*#__PURE__*/_jsx(UISection, {
  className: "m-top-4 text-right",
  children: /*#__PURE__*/_jsx(UIHelpIcon, {
    tooltipProps: {
      placement: 'top left'
    },
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "dashboard.timeZoneMessage.tooltip"
    }),
    children: /*#__PURE__*/_jsx(Small, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dashboard.timeZoneMessage.text",
        options: {
          offsetString: I18n.moment().portalTz().format('Z')
        }
      })
    })
  })
});

export default /*#__PURE__*/memo(TimeZoneMessage);